import React, { useEffect, useState } from "react";
import NewLoadingCircle from "../../NewLoadingCircle";

const PostingAccountsTable = ({ openFormForEdit }) => {
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError]     = useState(false);

  useEffect(() => {
    // Simulate a data fetch with a 1-second delay
    const timer = setTimeout(() => {
      try {
        // If you had real data, you'd fetch it here (e.g. via axios/fetch).
        // We’ll mock success:
        const mockData = [
          {
            id: 401,
            name: "Posting Manager A",
            email: "managerA@posting-accounts.com",
            companyType: "Finance",
            dobScrapeType: "Type A",
            companyName: "Posting Co.",
            password: "•••••",
          },
          {
            id: 402,
            name: "Posting Manager B",
            email: "managerB@posting-accounts.com",
            companyType: "Finance",
            dobScrapeType: "Type B",
            companyName: "Accounts R Us",
            password: "•••••",
          },
        ];

        // Set table data
        setTableData(mockData);
        // End loading
        setIsLoading(false);
      } catch (err) {
        console.error("Error loading PostingAccounts data:", err);
        setIsError(true);
        setIsLoading(false);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  // If still loading or there's an error, show the spinner / error
  if (isLoading || isError) {
    return (
      <NewLoadingCircle
        isLoading={isLoading}
        isError={isError}
        errorMessage="Failed to load Posting Accounts data."
      />
    );
  }

  // Otherwise, render your table
  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Posting Accounts Table</h2>

      <table className="min-w-full border border-gray-300">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 text-left">Name</th>
            <th className="px-4 py-2 text-left">Email</th>
            <th className="px-4 py-2 text-left">Company Type</th>
            <th className="px-4 py-2 text-left">DOB Scrape Type</th>
            <th className="px-4 py-2 text-left">Company Name</th>
            <th className="px-4 py-2 text-left">Password</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((row) => (
            <tr
              key={row.id}
              className="border-b hover:bg-gray-100 cursor-pointer"
              onClick={() => {
                if (openFormForEdit) {
                  openFormForEdit(row);
                }
              }}
            >
              <td className="px-4 py-2 text-blue-600 underline">
                {row.name}
              </td>
              <td className="px-4 py-2">{row.email}</td>
              <td className="px-4 py-2">{row.companyType}</td>
              <td className="px-4 py-2">{row.dobScrapeType}</td>
              <td className="px-4 py-2">{row.companyName}</td>
              <td className="px-4 py-2">{row.password}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PostingAccountsTable;
